import { useMutation } from "react-query";
import force from "./force";
export default function useForce(options) {
    return useMutation("force", force, options);
}
